<template>
  <section class="admin-content" id="contact-search">
    <div class="bg-info m-b-30">
      <div class="container">
        <div class="row p-b-60 p-t-60">
          <div class="col-md-6 text-center mx-auto text-white p-b-30">
            <div class="m-b-10">
              <div class="avatar">
                <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
              </div>
            </div>
            <p class="h4">
              <strong>Self Enrollment Form </strong>
            </p>
          </div>
        </div>
      </div>
    </div>

    <main class="admin-main">
      <section class="container">
        <div class="">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="text-center">
                    <p>
                      (All fields marked with
                      <span class="text-danger">*</span> are compulsory)
                    </p>
                  </div>
                  <form @submit.prevent="submitForm">
                    <div class="form-row">
                      <!-- <div class="col-md-6">
                        <div class="form-group">
                          <label for="inputCity"
                            >Sector <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            required
                            disabled
                            v-model="sector"
                          >
                            <option value="formal">Formal Sector</option>
                            <option value="informal">Informal Sector</option>
                          </select>
                        </div>
                      </div> -->

                      <!-- <div class="col-md-6" v-if="sector == 'informal'">
                        <div class="form-group">
                          <label for="inputCity"
                            >Category<span class="text-danger">*</span></label
                          >
                          <select
                          disabled
                            class="form-control"
                            required
                            v-model="register.sector"
                          >
                         

                            <option value="Voluntary Contributor">
                              Voluntary Contributor
                            </option>
                          </select>
                        </div>
                      </div> -->

                      <!-- <div class="col-md-6">
                        <div class="form-group">
                          <label for="inputCity"
                            >Select Plan Type
                            <span class="text-danger">*</span></label
                          >
                          <select
                          disabled
                            class="form-control"
                            required
                            v-model="register.plan_type"
                          >
                            <option value="Individual">Individual</option>
                          </select>
                        </div>
                      </div> -->

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Last Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.lastname"
                          placeholder="Last Name" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputEmail4">First Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.firstname"
                          placeholder="First Name" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Middle Name</label>
                        <input type="text" class="form-control" v-model="register.middlename"
                          placeholder="Middle Name" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">NIN 
                        </label>
                        <input type="text" pattern="\d*" maxlength="11" class="form-control"
                          v-model="register.nimc_number" placeholder="NIN" />
                      </div>

                      <div class="form-group col-md-6">
                        <p>
                          <label for="inputPassword4">Date of Birth <span class="text-danger">*</span>
                          </label>
                        </p>

                        <input type="date" required class="form-control" v-model="register.dob"
                          placeholder="DD/MM/YYYY" />
                      </div>

                      <div class="form-group col-md-6">
                        <label>Special Needs</label>
                        <select class="form-control" v-model="register.category_of_vulnerable_group">
                          <option value="Pregnant Women">Pregnant Women</option>
                          <option value="Children under 5">
                            Children under 5
                          </option>
                          <option value="Aged">Aged</option>
                          <option value="People with Special Needs">
                            People with Special Needs
                          </option>
                          <option value="Poorest of the Poor">
                            Poorest of the Poor
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">Email </label>
                        <input type="email" class="form-control" v-model="register.email" placeholder="Email" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Phone Number
                          <span class="text-danger">*</span></label>
                        <input v-phone type="text" required pattern="\d*" class="form-control"
                          v-model="register.phone_number" placeholder="Phone Number" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputCity">Gender <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.gender">
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Marital Status
                          <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.marital_status">
                          <option value="Married">Married</option>
                          <option value="Widow">Widow</option>
                          <option value="Single">Single</option>
                          <option value="Separated">Separated</option>
                          <option value="Divorced">Divorced</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">Area Council
                          <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.localgovt"
                          @change="getProvidersByLGAs($event)">
                          <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>

                      <!--
                      <div class="form-group col-md-6">
                        <label>Ward </label>
                        <select
                          class="form-control"
                          v-model="register.ward"
                          @change="getProvidersByWards($event)"
                        >
                          <option
                            v-for="ward in wards"
                            v-bind:key="ward.id"
                            :value="ward.id"
                          >
                            {{ ward.ward_name }}
                          </option>
                        </select>
                      </div> -->

                      <div class="form-group col-md-6">
                        <label>Facility for Accessing Health Care
                          <span class="text-danger">*</span>
                          <button @click="getProviders" type="button" class="btn btn-outline-info btn-sm m-1">
                            Get all Providers
                          </button>
                        </label>
                        <v-select v-model="register.provider_id" :options="providers" label="agency_name"
                          :value="register.provider_id"></v-select>
                        <small v-if="register.localgovt && !(providers || []).length" class="text-muted d-block mt-1">No facility listed for this LGA or ward. Click <b>All</b> to choose from every facility in the state.</small>
                      </div>

                      <div class="form-group col-md-6"
                      v-if="$route.params.agency_id == 930972"
                      >
                        <label>Select Group <span class="text-danger">*</span> </label>

                        <select class="form-control" v-model="register.place_of_work" @change="getDepts" required>
                          <option v-for="mda in mdas" :key="mda.name" :value="mda">
                            {{ mda.name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6" v-if="tpas.length > 0">
                        <label for="inputCity">HMO <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.org_id">
                          <option v-for="org in tpas" v-bind:key="org" :value="org.id">
                            {{ org.organization_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">Blood Group</label>
                        <select class="form-control" v-model="register.blood">
                          <option value="">NA</option>
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputAddress">Home Address <span class="text-danger">*</span></label>
                        <input required type="text" class="form-control" v-model="register.address"
                          placeholder="1234 Main St" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity"> Select Marketer</label>
                        <select class="form-control" v-model="register.enrolled_by">
                          <option :value="emoployee.id" v-for="emoployee in employees.data" v-bind:key="emoployee.id">
                            {{ emoployee.firstname }} {{ emoployee.lastname }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-12">
                        <button class="btn btn-outline-info" type="button" @click="takePicAndroid">
                          Capture Photo <i class="fe fe-camera"></i>
                        </button>
                        <small class="d-block text-muted mt-2">Optional: add enrollee picture during enrollment.</small>
                      </div>

                      <div class="form-group col-md-6" v-if="register.user_image">
                        <img
                          :src="register.user_image"
                          class="rounded img-fluid"
                          alt="Enrollee Photo"
                          onerror="this.onerror=null; this.src='/assets/img/claimify_logo.png'"
                        />
                      </div>
                    </div>

                    <div class="col-md-12 mt-4">
                      <p class="h5">Our Services Include:</p>

                      <button type="button" @click="selectSuggestion(rev)" v-for="rev in services" :key="rev"
                        class="btn m-b-15 mx-2 badge badge-soft-dark">
                        {{ rev }}
                      </button>
                    </div>

                    <div>
                      <p class="mb-2">
                        <strong>
                          Declaration & warranty on behalf of all persons
                          proposed to be insured</strong>
                      </p>

                      <div class="form-group">
                        <div class="form-check">
                          <label class="form-check-label" for="checkbox1">
                            I/We hereby declare, on my behalf and on behalf of
                            all persons proposed to be insured that the above
                            statements, answers and/or particulars given by me
                            are true and complete in all respects to the best of
                            my knowledge and that I/We am/ are authorized to
                            propose on behalf of these other persons.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <label class="form-check-label" for="checkbox1">
                            I understand that the information provided by me
                            will form the basis of insurance policy, is subject
                            to the Board approved underwriting policy of
                            {{ agency.firstname }}
                            and that the policy will come into force only after
                            full receipt of the premium chargeable.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <label class="form-check-label" for="checkbox1">
                            I/ We further declare that I/We will notify in
                            writing any change occurring in the occupation or
                            general health of the life to be insured/ proposer
                            after the proposal has been submitted but before
                            communication of the risk acceptance by
                            {{ agency.firstname }}.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <label class="form-check-label" for="checkbox1">
                            I/We declare and consent to
                            {{ agency.firstname }} seeking medical information
                            from any hospital who at any time has attended on
                            the life to be insured/ proposer or from any past or
                            present employer concerning anything which affects
                            the physical and mental health of the life to be
                            assured/proposer and seeking information from any
                            insurance company to which an application for
                            insurance on the life to be assured/ proposer has
                            been made for the purpose of underwriting the
                            proposal and/or claim settlement.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <label class="form-check-label" for="checkbox1">
                            I/ We authorize {{ agency.firstname }} to share
                            information pertaining to my proposal including the
                            medical records for the sole purpose of proposal
                            underwriting and/or claims settlement and with any
                            Governmental and/or Regulatory Authority.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input required class="form-check-input" type="checkbox" id="checkbox1" />
                          <label class="form-check-label" for="checkbox1">
                            Click to Agree to all Terms Above.
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <button type="submit" class="btn btn-info btn-block btn-lg">
                        Submit <i class="fe fe-send"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
            </div>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";

  export default {
    components: {
      Loading,
    },
    data() {
      return {
        agency: "",
        sms_message:
          "Your Enrollment was successful. Your ID is ",
        isLoading: false,
        fullPage: true,
        services: [
          "Dental Care",
          "Surgery",
          "General Consultation",
          "Ante-natal Care",
          "Deliveries",
          "Post-natal Care",
          "Ear Nose & Throat Care",
          "Eye Care",
          "Emergency Care",
          "X-ray",
          "Ultrasound",
          "Laboratory",
          "Orthopaedic",
          "Physiotherapy",
          "Skincare",
          "Mental Care",
          "Internal Medicine",
          "Child Healthcare",
        ],
        employees: "",
        states: "",
        show: false,
        clients: "",
        providers: "",
        sector: "informal",
        mdas: "",
        wards: "",
        tpas: "",
        providers_wards: "",
        state: "",
        OfficerDetails: "",
        current_page: "",
        selected_provider: "",
        selected_provider_dependents: "",
        image: "",
        imagefile: null,
        lga_states: "",
        response: "",
        register: {
          user_image: "",
          firstname: "",
          lastname: "",
          middlename: "",
          nimc_number: "",
          email: "",
          phone_number: "",
          type: "client",
          agency_id: "",
          state: "",
          localgovt: "",
          ward: "",
          address: "",
          blood: "",
          gender: "",
          genotype: "",
          dob: "",
          expiry_date: new Date(),
          salary_number: "",
          provider_id: "",
          point_of_care: "",
          sector: "Voluntary Contributor",
          finger_print: "",
          place_of_work: "",
          plan_type: "Individual",
          org_id: "",
          grade_level: "",
          date_of_entry: "",
          marital_status: "",
          category_of_vulnerable_group: "",
        },
      };
    },
    beforeMount() {
      
       this.axios
          .get(`/api/v1/auth/hmos/${this.$route.params.agency_id}`)
          .then((response) => {
            this.agency = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });


    },
    computed: {
      addYear() {
        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var c = new Date(year + 1, month, day);
        // var c = new Date(year + 1);
        console.log(c);
        return c;
      },
    },

    methods: {
      submitForm() {
        if (this.register.provider_id == "") {
          this.$toasted.error(`Provider not Selected!`, {
            position: "top-center",
            duration: 3000,
          });
        } else {
          if (confirm("Are you sure you want to submit?")) {
            this.registerUserAdmin();
          }
        }
      },

      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/${event.target.value}`)
          .then((response) => {
            this.wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/${this.$route.params.state}`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      registerUserAdmin() {
        this.isLoading = true;
        let snap = localStorage.getItem("voluntary_snap");

        this.axios
          .post("/api/v1/auth/register", {
            nimc_number: this.register.nimc_number,
            firstname: this.register.firstname.toUpperCase(),
            lastname: this.register.lastname.toUpperCase(),
            middlename: this.register.middlename.toUpperCase(),
            email: this.register.email,
            plan_type: this.register.plan_type,
            phone_number: this.register.phone_number,
            type: this.register.type,
            sectorType: this.sector,
            user_image: this.register.user_image || snap || "",
            agency_id: this.$route.params.agency_id,
            provider_id: this.register.provider_id.id,
            state: this.$route.params.state,
            role: 0,
            password: "jacobi",
            localgovt: this.register.localgovt,
            ward: this.register.ward,
            blood: this.register.blood,
            dob: this.register.dob,
            address1: this.register.address,
            genotype: this.register.genotype,
            gender: this.register.gender,
            sector: this.register.sector,
            place_of_work: this.register.place_of_work.name,
            org_id: this.register.org_id,
            enrolled_by: this.register.enrolled_by,
            finger_print: this.register.finger_print,
            salary_number: this.register.salary_number,
            grade_level: this.register.grade_level,
            date_of_entry: this.register.date_of_entry,
            marital_status: this.register.marital_status,
            category_of_vulnerable_group:
              this.register.category_of_vulnerable_group,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            // this.sendSMS(response.data.data);
            this.$toasted.info("Submited Successfully!", {
              position: "top-center",
              duration: 8000,
            });
            let user_id = response.data.data.id;

            this.$router.push(
              `/subscribe/${this.$route.params.agency_id}/${user_id}`
            );
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            const data = error.response && error.response.data;
            let message;
            if (data && data.errors) {
              this.response = data.errors;
              message = JSON.stringify(data.errors);
            } else if (data && data.message) {
              message = data.message;
            } else {
              message =
                "Could not reach the server. If you attached a photo, try a smaller one, then check your connection and submit again.";
            }
            this.$toasted.error(message, {
              position: "top-center",
              duration: 6000,
            });
          });
      },

      sendSMS() {
        // Disabled: this called multitexter.com's SMS API with a hardcoded
        // credential embedded in frontend source (a leaked secret visible to
        // every browser). Re-enable only via a backend endpoint that holds
        // the credential server-side.
        console.warn("sendSMS() is disabled pending a backend SMS endpoint.");
      },

      getProviders() {
        this.axios
          .get(`/api/v1/auth/providerAgency/${this.$route.params.agency_id}`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProvidersByLGAs() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(
            `/api/v1/auth/providerAgencies/${this.$route.params.agency_id}/${this.register.localgovt}`
          )
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProvidersByWards() {
        this.axios
          .get(
            `/api/v1/auth/providerAgencies/${this.$route.params.agency_id}/${this.register.localgovt}/${this.register.ward}`
          )
          .then((response) => {
            this.providers_wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getTPAs() {
        this.user = JSON.parse(localStorage.getItem("user"));

        this.axios
          .get(`/api/v1/auth/org_agency/${this.$route.params.agency_id}`)
          .then((response) => {
            this.tpas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getEmployees() {
        this.axios
          .get(`/api/v1/auth/getEmployee/${this.$route.params.agency_id}`, {
            params: {
              job_title: "marketer",
            },
          })
          .then((response) => {
            this.employees = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getDepts() {
        this.register.org_id = this.register.place_of_work.hmo_id;
        console.log(this.register.org_id);
      },
      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministry`,{
            params: {
              type: 'individual',
              agency_id: this.$route.params.agency_id,
            },
          })
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      compressImage(dataUrl, maxSize = 1024, quality = 0.75) {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
            const canvas = document.createElement("canvas");
            canvas.width = Math.round(img.width * scale);
            canvas.height = Math.round(img.height * scale);
            const ctx = canvas.getContext("2d");
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL("image/jpeg", quality));
          };
          img.onerror = () => resolve(dataUrl);
          img.src = dataUrl;
        });
      },
      async takePicAndroid() {
        try {
          const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Base64,
            source: CameraSource.Camera,
          });

          this.register.user_image = await this.compressImage(
            `data:image/jpeg;base64,${image.base64String}`
          );
          this.$toasted.info("Image taken Successfully!", {
            position: "top-center",
            duration: 8000,
          });
        } catch (error) {
          // Photo is optional; user may cancel camera.
          console.error(error);
        }
      },
    },
    created() {
      this.getProviders();
      this.getEmployees();
      this.fetchLga();
      this.getMDAs();
      this.getTPAs();
    },
  };
</script>